import Vue from 'vue'
import App from './App.vue'
import router from './router' // vue-router
import ElementUI from 'element-ui' // ele js
import './assets/element/theme/index.css';// ele css 自定义
// import Avue from '@smallwei/avue';
// import '@smallwei/avue/lib/index.css';
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
import {config} from './config' // 全局api接口
import api from './api/index' // 自定义axios
import store from './store' // vuex
import OSS from 'ali-oss' // 阿里云云oss包
import axios from 'axios' // axios
import utils from './utils/index'// 加载全局自定义函数
import AvueUeditor from './assets/avue-ueditor@0.1.4/index' // 编辑器

Vue.config.productionTip = false;

// 全局帮助函数
window.utils = utils
Vue.use(Avue);
Vue.use(ElementUI);
Vue.use(AvueUeditor);

// avue 必须重新引入
window.axios = axios
// 全局引入OSS
window.OSS = OSS

Vue.prototype.api = api // axios请求
Vue.prototype.config = config; // 全局配置

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
